export default "__VITE_ASSET__CzF8kfWB__"